export enum PaymentType {
  BANESCO_CC_PAYMENT = 'BANESCO_CC_PAYMENT',
  BANESCO_INTERNAL = 'BNSC_BSS_TRANSFER',
  BANESCO_TDC_TRANSFER = 'BNSC_BSS_TDC_TRANSFER',
  BANESCO_LOAN_PAYMENT = 'BANESCO_LOAN_PAYMENT',
  BANESCO_LOAN_TRANSFER = 'BNSC_BSS_LOAN_TRANSFER',
  WITHIN_BANK_TRANSFER = 'WITHIN_BANK_TRANSFER',
  BANESCO_CC_PAYMENT_OTP = 'BANESCO_CC_PAYMENT_OTP',
  WITHIN_BANK_TRANSFER_OTP = 'WITHIN_BANK_TRANSF_OTP',
  BANESCO_LOAN_PAYMENT_OTP = 'BANESCO_LOAN_PAYMENT_OTP',
  BANESCO_STOCK_TRANSFER = 'BNSC_BSS_STOCK_TRANSFE',
  INTERNATIONAL_TRANSFER = 'BNSC_BSS_INTERN_TRANSF',
  REGIONAL_TRANSFER = 'BNSC_BSS_REGION_TRANSF',
  BNSC_BSS_TAXES_TRANSF = 'BNSC_BSS_TAXES_TRANSF',
  SERVICE_TRANSFERS = 'BNSC_BSS_SERVIC_TRANSF',
  BANESCO_OTHER_BANKS = 'BNSC_BSS_W_BANK_TRANSF',
  BANESCO_OTHER_BANKS_TDC = 'BNSC_BSS_W_TDC_TRANSF',
  BNSC_BSS_PAYMENT_PAYROLL = 'BNSC_BSS_PAYMENT_PAYROLL_MANUAL',
}
